import React, { Component } from 'react'
import _ from 'lodash'
import { toast } from 'react-toastify'
import { connect } from 'react-redux'

import { Get, Post, Put, Delete } from 'utils/axios'
import { requestError, requestSuccess } from 'utils/requestHandler'
import TransComponent from 'components/Trans'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      caseTypes: [],
      selectedType: {},
      showCreateType: false,
      showUpdateType: false,
      showConfirmDeleteModal: false,
      searchParams: [],
      caseTypesOptionsEN: [],
      caseTypesOptionsDE: []

    }

    load = param => this.setState({ loading: param })
    requestError = error => toast.error( error )
    requestSuccess = success => toast.success( success )

    onChangeTypesHOC = ( key, val ) => this.setState({ [ key ]: val })

    getTypes = (query, showLoading = false) => Get(
      `/types?query=${query}`,
      this.getTypesSuccess,
      this.getTypesError,
      v => {
        if(showLoading){
          this.load(v)
        }
      }
    )
    getTypesSuccess = payload => {
      let temp = _.map( payload.data, item => ({
        ... item,
        en_name: item?.name?.en??'',
        de_name: item?.name?.de??''
      }))
      this.setState({ caseTypes: temp })
    }
    getTypesError = error => requestError( error )

    getTypesOptions = query => Get(
      `/types?query=${query}`,
      this.getTypesOptionsSuccess,
      this.getTypesOptionsError,
      this.load
    )
    getTypesOptionsSuccess = payload => {
      let temp = _.map( payload.data, item => ({
        id: item.name?.en??'',
        name: item.name?.en??'',
      }))

      let tempDE = _.map( payload.data, item => ({
        id: item.name?.de??'',
        name: item.name?.de??'',
      }))
      this.setState({ 
        caseTypesOptionsEN: temp,
        caseTypesOptionsDE: tempDE
      })
    }
    getTypesOptionsError = error => requestError( error )

    createType = data => Post(
      `/types`,
      data,
      this.createTypeSuccess,
      this.createTypeError,
      this.load
    )
    createTypeSuccess = payload => {
      requestSuccess( 'Case type is created successfully.' )
      this.setState({ showCreateType: false })
      this.getTypes()
    }
    createTypeError = error => requestError( error )

    updateType = ( id, data ) => Put(
      `/types/${ id }`,
      data,
      this.updateTypeSuccess,
      this.updateTypeError,
      this.load
    )
    updateTypeSuccess = payload => {
      requestSuccess( 'Case type is updated successfully.' )
      this.getTypes()
    }
    updateTypeError = error => requestError( error )

    deleteType = id => Delete(
      `/types/${ id }`,
      this.deleteTypeSuccess,
      this.deleteTypeError,
      this.load
    )
    deleteTypeSuccess = () => {
      requestSuccess( 'Case type is removed successfully.' )
      this.setState({ showConfirmDeleteModal: false })
      this.getTypes()
    }
    deleteTypeError = error => requestError( error )

    render = () => {
      return (
        <WrappedComponent
          { ...this.props }
          caseTypes={ this.state.caseTypes }
          selectedType={ this.state.selectedType }
          searchParams={ this.state.searchParams }
          showCreateType={ this.state.showCreateType }
          showUpdateType={ this.state.showUpdateType }
          onLoadTypes={ this.state.loading }
          showConfirmDeleteModal={ this.state.showConfirmDeleteModal }
          caseTypesOptionsEN={ this.state.caseTypesOptionsEN }
          caseTypesOptionsDE={ this.state.caseTypesOptionsDE }

          getTypesOptions={ this.getTypesOptions }
          onChangeTypesHOC={ this.onChangeTypesHOC }
          getTypes={ this.getTypes }
          createType={ this.createType }
          updateType={ this.updateType }
          deleteType={ this.deleteType } />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return  connect( mapStateToProps )( WithHOC )
}

export default HOC